import React, { Component } from "react";
import MarketplaceAchievements from '../home/MarketplaceAchievements';
import MarketplacePastClasses from '../home/MarketplacePastClasses';
import AchievementPopup from '../home/AchievementPopup';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';
import moment from 'moment';
import MainLoader from '../home/MainLoader';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceMyProfile extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		currentUserData: JSON.parse(localStorage.getItem('userData')),
		openAchievements: false,
		achievementType: '',
		openPastClasses: false,
		myStatistics: {},
		achieveData: [],
		achieveDates: [],
		showMilestones: 'All',
		showLoader: false,
		openAchievementPopup: false,
		openedAchievement: {}
    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
}

showMilestones = (mod) =>{
	this.setState({
		showMilestones: mod
	});
}

updateStateFromChild=(state)=>{
	console.log('myProfile');
	this.setState(state);
}

openAchievemens=(mod, mod2)=>{
	
	let allTrophies = mod2;
	var trophyDates = [];
	var allData = [];
	
	var currentDate = new Date();
	var tomorrowDate = new Date().setDate(new Date().getDate() + 1);
	var yesterday = new Date().setDate(new Date().getDate() - 1);
	
	if ( mod == 'recent' )
		{
			for ( var i = 0; i < allTrophies.length; i++ )
				{
					var item = allTrophies[i];
					
					var date = moment(item.achieveDate).format('dddd, DD MMMM');
					
					if ( moment(currentDate).format('dddd, DD MMMM') == moment(item.achieveDate).format('dddd, DD MMMM') )
						{
							date = 'Today, ' + moment(item.achieveDate).format('DD MMM');
						}
						
					if ( moment(yesterday).format('dddd, DD MMMM') == moment(item.achieveDate).format('dddd, DD MMMM') )
						{
							date = 'Yesterday, ' + moment(item.achieveDate).format('DD MMM');
						}
						
					if ( trophyDates.indexOf(date) == -1 ) { trophyDates.push(date); }
				}

			for ( var y = 0; y < trophyDates.length; y++ )
				{
					for ( var z = 0; z < allTrophies.length; z++ )
						{
							var itemClass = allTrophies[z];
							
							var dateSession = moment(itemClass.achieveDate).format('dddd, DD MMMM');
							
							if ( moment(currentDate).format('dddd, DD MMMM') == moment(itemClass.achieveDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Today, ' + moment(itemClass.achieveDate).format('DD MMM');
								}
								
							if ( moment(yesterday).format('dddd, DD MMMM') == moment(itemClass.achieveDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Yesterday, ' + moment(itemClass.achieveDate).format('DD MMM');
								}
								
								
							if ( dateSession == trophyDates[y] )
								{
									if ( !allData[dateSession] ) { allData[dateSession] = []; }
									
									allData[dateSession].push(itemClass);
								}
						}
				}
		}
	else
		{
			for ( var i = 0; i < allTrophies.length; i++ )
				{
					var item = allTrophies[i];
					
					var date = moment(item.achieveDate).format('MMMM');
					
					if ( trophyDates.indexOf(date) == -1 ) { trophyDates.push(date); }
				}

			for ( var y = 0; y < trophyDates.length; y++ )
				{
					for ( var z = 0; z < allTrophies.length; z++ )
						{
							var itemClass = allTrophies[z];
							
							var dateSession = moment(itemClass.achieveDate).format('MMMM');
							
							if ( dateSession == trophyDates[y] )
								{
									if ( !allData[dateSession] ) { allData[dateSession] = []; }
									
									allData[dateSession].push(itemClass);
								}
						}
				}
		}
	
	this.setState({
		achieveDates: trophyDates,
		achieveData: allData,
		openAchievements: true,
		achievementType: mod,
	});
}

openPastClasses = ()=>{
	this.setState({
		openPastClasses: true
	});
}

getMyStatistics = ()=>{
	let token = this.state.currentUserData.token;
    axiosVirdio.auth(token);
	
	var newDate = new Date();
	var startDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
	
	var currentDayInMonth = newDate.getDate();
	var lastMonthStartDate = new Date(newDate.getFullYear(), newDate.getMonth()-1, 1);
	var lastMonthEndDate = new Date(newDate.getFullYear(), newDate.getMonth()-1, currentDayInMonth);
	
	let postData = {
			startDate: startDate,
			endDate: newDate,
			lastMonthStartDate: lastMonthStartDate,
			lastMonthEndDate: lastMonthEndDate
		};
	
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getMyStatistics', postData).then(res => {
		
		var mainResponse = res.data.responseData;
		
		this.setState({
			myStatistics: mainResponse
		});
		this.props.updateStateFromChild({showLoader: false});	
	}).catch(err =>{
		this.props.updateStateFromChild({showLoader: false});
	});
}

updateUserData = ()=>{
	this.setState({
		currentUserData: JSON.parse(localStorage.getItem('userData'))
	});
}

closePastClasses = () =>{
	this.setState({openPastClasses: false});
}

showAchievementPopup = (mod) =>{
	console.log(mod);
	let openedAchievement = mod;
	this.setState({
		openedAchievement: mod,
		openAchievementPopup: true,
	});
}

closeAchievementPopup = () =>{
	this.setState({openAchievementPopup: false});
}

  render() {
	 return (
		<div>
			<div className="myProfileBack">
				<div className="profileData">
					<div className="outImg">
						<div className="profImg" style={{ backgroundImage: this.state.currentUserData.image && this.state.currentUserData.image.indexOf('.s3') > -1 ? "url("+this.state.currentUserData.image+")" : "url(./images/user_avatar.svg)"}}></div>
					</div>
				</div>
			</div>
			{ this.state.currentUserData.isMarketplaceUser == 1 &&
				<div>
					<div className="lftPart">
							<div className="profName">{this.state.currentUserData.firstName} {this.state.currentUserData.lastName}</div>
							{ this.state.currentUserData.city &&
								<div className="profLocation">{this.state.currentUserData.city} 
									{ this.state.currentUserData.state &&
										<span>, {this.state.currentUserData.state}</span>
									}
								</div>
							}
						<div className="pastClassesB" onClick={() => this.openPastClasses()}>Past Classes</div>
					</div>
					<div className="rghtPart">
						<div className="profSection">Stats</div>
						<div className="statsPart">
							<div className="oneStreak">
								<div className="streakSign"></div>
								<div className="streakName">Workout streak</div>
								<div className="streakValue">{this.state.myStatistics.workoutStreak} days</div>
								<div className="bestStreak mrgtp16">Best streak</div>
								<div className="bestStreakValue">{this.state.myStatistics.bestWorkoutStreak} days</div>
							</div>
							<div className="oneStreak">
								<div className="streakSign streakStar"></div>
								<div className="streakName">Goal streak</div>
								<div className="streakValue">{this.state.myStatistics.goalStreak} weeks</div>
								<div className="bestStreak mrgtp16">Best streak</div>
								<div className="bestStreakValue">{this.state.myStatistics.bestGoalStreak} week</div>
								<div className="workTimes">Workout {this.state.myStatistics.workoutTimesAWeek} times a week</div>
							</div>
							<div className="oneStreak">
								<div className="streakSign streakBadge"></div>
								<div className="streakName">Leaderboard position</div>
								<div className="streakValue profGraph">{this.state.myStatistics.leaderBoardPosition}</div>
								<div className="bestStreak mrgtp16">Best position</div>
								<div className="bestStreakValue">{this.state.myStatistics.bestLeaderBoardPosition}</div>
							</div>
							<div className="oneStreak">
								<div className="streakSign streakStrength"></div>
								<div className="streakName">Workouts this month</div>
								{ this.state.myStatistics && this.state.myStatistics.thisMonth > 0 ?
									<div className="streakValue">{this.state.myStatistics.thisMonth}</div>
									:
									<div className="streakValue">0</div>
								}
								<div className="bestStreak mrgtp16">Best</div>
								<div>
									<div className="leftInfo">
										<div className="bestStreakValue">{this.state.myStatistics.bestMonthValue}</div>
									</div>
									<div className="rightInfo">
										{ this.state.myStatistics && this.state.myStatistics.bestMonth ?
											<div className="bestStreakInfo">{this.state.myStatistics.bestMonth}</div>
											:
											<div className="bestStreakInfo">&nbsp;</div>
										}
									</div>
								</div>
								<div className="infoTrend">Trend</div>
								<div>
									<div className="leftInfo">
										<div className={"bestStreakValue " + ( this.state.myStatistics.differenceThisAndLast < 0 ? "downArrow" : "upArr")}>{Math.abs(this.state.myStatistics.differenceThisAndLast)}</div>
									</div>
									<div className="rightInfo">
										<div className="bestStreakInfo">from last month</div>
									</div>
								</div>
							</div>
							<div className="oneStreak">
								<div className="streakSign favHeart"></div>
								<div className="streakName">Favorite Instructor</div>
								<div className="outInst">
									<div>
										{ (this.state.myStatistics && this.state.myStatistics.instructorId) ?
											<div className="favInstAvatar" style={{ backgroundImage: this.state.myStatistics && this.state.myStatistics.instructorImage && this.state.myStatistics.instructorImage.indexOf('.s3') > -1 ? "url("+this.state.myStatistics.instructorImage+")" : "url(/images/user_avatar.svg)"}}></div>
											:
											<div></div>
										}
										{ this.state.myStatistics && this.state.myStatistics.instructorId ?
											<div className="instructorName">{this.state.myStatistics.instructorFirstName} {this.state.myStatistics.instructorLastName}</div>
											:
											<div className="instructorName">&nbsp;</div>
										}
									</div>
									<div className="bestStreak mrgtp16 classAtte">Classes attended</div>
									{ this.state.myStatistics && this.state.myStatistics.instructorId ?
										<div className="bestStreakValue">{this.state.myStatistics.instructorSessionNumber}</div>
										:
										<div className="bestStreakValue">&nbsp;</div>
									}
								</div>
							</div>
						</div>
						<div className="profSection mrgtp22">Achievements</div>
						<div className="oneStreakW">
							{ this.state.myStatistics && this.state.myStatistics.recentAchievements && this.state.myStatistics.recentAchievements.length > 0 &&
								<div className="achiRghtArr" onClick={() => this.openAchievemens('recent', this.state.myStatistics.recentAchievements)}></div>
							}
							<div className="achiSub">Recent</div>
							<div className="achieveCont">
							{ this.state.myStatistics && this.state.myStatistics.recentAchievements && this.state.myStatistics.recentAchievements.length > 0 ?
								<div>
									{this.state.myStatistics['recentAchievements'].map((mod, index) =>
										<div className="oneAchieve" key={index} onClick={() => this.showAchievementPopup(mod)}>
											{ index < 10 &&
												<div>
													<div className="achieveTroph"></div>
													<div className="achieveInfo">
														<div className="achieveVal">{mod['value']}</div>
														<div className="achieveVal">{mod['name']}</div>
													</div>
												</div>
											}
										</div>
									)}
								</div>
								:
								<div className="noAchieveText" >No data</div>
							}
							
							</div>
						</div>
						<div className="oneStreakW">
							{ this.state.myStatistics && this.state.myStatistics.recentAchievements && this.state.myStatistics.recentAchievements.length > 0 &&
								<div className="achiRghtArr" onClick={() => this.openAchievemens('monthly', this.state.myStatistics.recentAchievements)}></div>
							}
							<div className="achiSub">Monthly</div>
							<div className="achiSub2">This month</div>
							<div className="achieveCont">
								{ this.state.myStatistics && this.state.myStatistics.monthlyAchievements && this.state.myStatistics.monthlyAchievements.length > 0 &&
									<div>
										{this.state.myStatistics['monthlyAchievements'].map((mod, index) =>
											<div className="oneAchieve" key={index} onClick={() => this.showAchievementPopup(mod)}>
												{ index < 10 &&
													<div>
														<div className="achieveTroph"></div>
														<div className="achieveInfo">
															<div className="achieveVal">{mod['value']}</div>
															<div className="achieveVal">{mod['name']}</div>
														</div>
													</div>
												}
											</div>
										)}
									</div>
								}
								{ this.state.myStatistics && this.state.myStatistics.recentAchievements && this.state.myStatistics.recentAchievements.length == 0 &&
									<div className="noAchieveText" >No data</div>
								}
							</div>
						</div>
						<div className="oneStreakW">
							<div className="achiSub">Milestones</div>
							<div className="mileFilter">
								<div className={"oneMileFilter all " + (this.state.showMilestones == 'All' ? 'activ' : '')} onClick={() => this.showMilestones('All')}>All</div>
								<div className={"oneMileFilter " + (this.state.showMilestones == 'Strength' ? 'activ' : '')} onClick={() => this.showMilestones('Strength')}>Strength</div>
								<div className={"oneMileFilter " + (this.state.showMilestones == 'Cardio' ? 'activ' : '')} onClick={() => this.showMilestones('Cardio')}>Cardio</div>
								<div className={"oneMileFilter " + (this.state.showMilestones == 'Yoga' ? 'activ' : '')} onClick={() => this.showMilestones('Yoga')}>Yoga</div>
								<div className={"oneMileFilter " + (this.state.showMilestones == 'Stretch' ? 'activ' : '')} onClick={() => this.showMilestones('Stretch')}>Stretch</div>
							</div>
							<div className="achieveCont">
								{ this.state.myStatistics && this.state.myStatistics.milestones && this.state.myStatistics.milestones.length > 0 &&
									<div>
										{this.state.myStatistics['milestones'].map((mod, index) =>
											<div className={"oneAchieve " + (mod['achieveDate'] == '' ? 'locked ' : '') + ((this.state.showMilestones == 'All' || this.state.showMilestones == mod['name']) ? '' : 'd-none')} key={index} onClick={() => this.showAchievementPopup(mod)}>
												<div className="achieveTroph"></div>
												<div className="achieveInfo">
													<div className="achieveVal">{mod['value']}</div>
													<div className="achieveVal">{mod['name']}</div>
												</div>
												{mod['achieveDate'] == '' &&
													<div className="achieveLine">
														<div className="achievePercent" style={{width: mod['achievePercent']+"%"}}></div>
													</div>
												}
											</div>
										)}
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			}
			{ this.state.currentUserData.isMarketplaceUser == 0 &&
				<div>
				<div className="lftPart">
					<div className="profName">{this.state.currentUserData.firstName} {this.state.currentUserData.lastName}</div>
					{ this.state.currentUserData.city &&
						<div className="profLocation">{this.state.currentUserData.city} 
							{ this.state.currentUserData.state &&
								<span>, {this.state.currentUserData.state}</span>
							}
						</div>
					}
				</div>
				<MarketplacePastClasses
					isMarketplace0={true}
					updateStateFromChild={this.updateStateFromChild} 
				></MarketplacePastClasses>
				</div>
			}
			{ this.state.openAchievements &&
				<div>
					<MarketplaceAchievements 
					updateStateFromChild={this.updateStateFromChild} 
					achievementType={this.state.achievementType} 
					achieveData = {this.state.achieveData}
					achieveDates = {this.state.achieveDates}
					></MarketplaceAchievements>
				</div>
			}
			{ this.state.openPastClasses &&
				<div>
					<MarketplacePastClasses 
						updateStateFromChild={this.updateStateFromChild}
						failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}				
					></MarketplacePastClasses>
				</div>
			}
			{ this.state.openAchievementPopup &&
				<div>
					<AchievementPopup 
						closeAchievementPopup={this.closeAchievementPopup}
						openedAchievement = {this.state.openedAchievement}
					></AchievementPopup>
				</div>
			}
		</div>
    );
  }
}

export default connect(
  null,
  {
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(MarketplaceMyProfile);
